import FilterSection from './FilterSection';
import { DEFAULT_FILTER_GROUP, SEARCH_ONLY_FILTER_GROUP, DEFAULT_FILTER_GROUP_NAME } from './constants/filterSection.filterGroups';
export { DEFAULT_FILTER_GROUP, SEARCH_ONLY_FILTER_GROUP, DEFAULT_FILTER_GROUP_NAME };
export default FilterSection;